import React from "react";
import { useHistory } from "react-router-dom";
import { useAuthStatus } from "../../_common/hooks/auth/authHook";
import { URLS } from "../../_config";

interface SiteLogoProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  isCollapsed?: boolean;
}

const SiteLogo = ({ className, style, onClick, isCollapsed }: SiteLogoProps) => {
  const history = useHistory();
  const isAuthenticated = useAuthStatus();

  const handleLogoClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Navigate to dashboard if authenticated, otherwise to landing/login page
      if (isAuthenticated) {
        history.push(URLS.DASHBOARD.MAIN);
      } else {
        history.push(URLS.AUTH.LOGIN);
      }
    }
  };

  return (
    <img
      src={isCollapsed?"/images/logo-sm.png":"/images/dr-logo.png"}
      alt="Dr Job Logo"
      className={`${className || ''} ${isCollapsed ? 'logo-collapsed' : ''}`}
      style={{ 
        ...style, 
        cursor: 'pointer',
        ...(isCollapsed && { width: '30px', height: 'auto' })
      }}
      onClick={handleLogoClick}
    />
  );
};

export default SiteLogo;
